<template>
  <div class="setup-account">
    <h1>Set Up Your Account</h1>

    <div v-if="error">{{ error }}</div>

    <div v-else-if="!tokenValidated">
      <p>Validating invite...</p>
    </div>

    <div v-else>
      <form v-if="!registrationSuccess" @submit.prevent="submitAccount">
        <div>
          <label for="username">Choose Username:</label>
          <input
            id="username"
            v-model.trim="username"
            type="text"
            maxlength="50"
            required
          />
        </div>

     <div>
  <label for="password">Choose Password:</label>
  <input
    id="password"
    v-model.trim="password"
    type="password"
    required
    minlength="6"
  />
  <small class="help-text">
  Username must start with a letter and contain only letters, numbers, or underscores.  Password must be at least 6 characters.
  </small>
</div>


        <button type="submit" :disabled="isSubmitting">
          {{ isSubmitting ? 'Submitting...' : 'Set Up Account' }}
        </button>
      </form>

      <p v-if="message">
        {{ message }}
        <template v-if="registrationSuccess">
          <br><br>
          <router-link :to="`/login?username=${encodeURIComponent(username)}`">
            Click here to log in
          </router-link>
        </template>
      </p>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'SetupAccount',
  data() {
    return {
      token: '',
      username: '',
      password: '',
      tokenValidated: false,
      error: '',
      message: '',
      isSubmitting: false,
      registrationSuccess: false
    };
  },
  created() {
    this.token = this.$route.query.token;
    if (!this.token) {
      this.error = 'Invalid or missing token.';
      return;
    }

    axios.post('etherscan/validate_invite_token.php', { token: this.token })
      .then(res => {
        if (res.data.status === 'success') {
          this.tokenValidated = true;
        } else {
          this.error = res.data.message || 'Invalid or expired token.';
        }
      })
      .catch(() => {
        this.error = 'An error occurred while validating your invite.';
      });
  },
  methods: {
    isValidUsername(name) {
      return /^[a-zA-Z][a-zA-Z0-9_]{2,49}$/.test(name);
    },
    submitAccount() {
      if (!this.isValidUsername(this.username)) {
        this.message = 'Invalid username. Must start with a letter and contain only letters, numbers, or underscores.';
        return;
      }

      if (this.password.length < 6) {
        this.message = 'Password must be at least 6 characters.';
        return;
      }

      this.isSubmitting = true;
      axios.post('etherscan/complete_simple_invite.php', {
        token: this.token,
        username: this.username,
        password: this.password
      })
      .then(res => {
        if (res.data.status === 'success') {
          this.registrationSuccess = true;
          this.message = 'Account created successfully! You can now log in.';
        } else {
          this.message = res.data.message || 'Something went wrong.';
        }
      })
      .catch((err) => {
        this.message = 'An error occurred while completing your registration.' + err;
      })
      .finally(() => {
        this.isSubmitting = false;
      });
    }
  }
};
</script>

<style scoped>
.setup-account {
  max-width: 400px;
  margin: 0 auto;
  padding: 1em;
}
.help-text {
  display: block;
  margin-top: 4px;
  color: #666;
  font-size: 0.85em;
}
button {
  background-color: #4CAF50; /* green-blue */
  color: white;
  padding: 10px 18px;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.1s ease;
  margin-top: 16px;
  width: 100%;
}

button:hover:not(:disabled) {
  background-color: #45a049;
}

button:active:not(:disabled) {
  transform: scale(0.98);
}

button:disabled {
  background-color: #aaa;
  cursor: not-allowed;
}

</style>
